"use client";

import React from "react";
import { motion } from "framer-motion";
import "./DigitalSolutionsSection.scss";
import Image from "next/image";

const DigitalSolutionsSection = ({ solutions }) => {
  if (!solutions) return null;

  const { title, description, cards = [] } = solutions;

  return (
    <section className="digital-solutions-stack-section">
      <div className="section-header">
        <h2>{title}</h2>
        <p> {description}</p>
      </div>

      <div className="stack-wrapper">
        {cards.map((card, index) => (
          <div
            key={card.id}
            className={`stack-card ${card.className}`}
            style={{
              top: `${120 + index * 30}px`,
            }}
          >
            <div className="card-content">
              <div className="card-icon">
                <Image
                  src={card.icon}
                  alt={`${card.title} icon`}
                  width={48}
                  height={48}
                />
              </div>

              <h3>{card.title}</h3>

              <p>{card.description}</p>
            </div>

            <div className="card-image">
              <Image
                src={card.image}
                alt={card.title}
                width={120}
                height={120}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DigitalSolutionsSection;
